import React from 'react';
import { View } from 'react-native';
import ProgressBar from '@ramonak/react-progress-bar';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store/store';
import { styles } from './LoadingBar.styles';
import { themes } from 'src/theme/theme';

const LoadingBar: React.FC = () => {
  const progress = useSelector((state: RootState) => state.progress.progress);
  const showGlobalLoader = useSelector((state: RootState) => state.UI.showGlobalLoader);

  if (showGlobalLoader) return null; // Hide when full-screen loader is active

  return progress > 0 ? (
    <View style={styles.container}>
      <ProgressBar
        isLabelVisible={false}
        completed={progress}
        bgColor={themes.light.brand_blue[3]}
        baseBgColor={themes.light.gray_blue[6]}
        height="4px"
      />
    </View>
  ) : null;
};

export default LoadingBar;
